import React from 'react';
import { useIntl } from 'react-intl';
import { LocalizedLink as Link } from 'gatsby-theme-i18n';
import FormContainer from '../Form/form-container';
import FormHeadline from '../FormHeadline/form-headline';
import CheckBox from '../Form/checkbox';
import Sun from '../Icons/sun';
import Moon from '../Icons/moon';

export default function Meal({ set, meal }) {
  const intl = useIntl();
  const nextStepPath = '/get-quote/hob';

  return(
    <FormContainer>
      <FormHeadline>{intl.formatMessage({ id: "quoteMealTypeHeadline" })}</FormHeadline>

      <Link to={nextStepPath}>
        <CheckBox checked={meal === 'lunch'} handleClick={() => set({meal: 'lunch'})}>
          <div>
            <Sun color={'#333'} />
            <div>{intl.formatMessage({ id: "quoteMealTypeLunch" })}</div>
          </div>
        </CheckBox>
      </Link>

      <Link to={nextStepPath}>
        <CheckBox checked={meal === 'dinner'} handleClick={() => set({meal: 'dinner'})}>
          <div>
            <Moon color={'#333'} />
            <div>{intl.formatMessage({ id: "quoteMealTypeDinner" })}</div>
          </div>
        </CheckBox>
      </Link>
    </FormContainer>
  );
}
